import { withFormConnected } from 'components/styleguide/HOC/index';
// eslint-disable-next-line import/no-named-as-default
import DRAWERS from 'components/common/Drawers/constants';

const Enhancer = (c) => withFormConnected(c, { formId: DRAWERS.CLEARANCES_USES_AND_DURATIONS });

export default Enhancer;
